import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

interface SummaryCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
  valueClassName?: string;
}

export default function SummaryCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  className = '',
  valueClassName = 'text-text-header'
}: SummaryCardProps) {
  return (
    <div className={`card ${className}`}>
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-sm font-medium text-text-muted mb-1">{title}</h3>
          <p className={`text-3xl font-bold tracking-tight ${valueClassName}`}>
            {typeof value === 'number' ? formatCurrency(value) : value}
          </p>
        </div>
        {icon && (
          <div className="p-2 bg-background-subtle rounded-lg text-primary border border-border">
            {icon}
          </div>
        )}
      </div>
      
      {(subtitle || trend) && (
        <div className="mt-4 flex items-center text-sm">
          {trend && (
            <span className={`flex items-center gap-1 mr-3 px-2 py-0.5 rounded-full text-xs font-medium ${
              trend.isPositive 
                ? 'text-success bg-success-bg' 
                : 'text-danger bg-danger-bg'
            }`}>
              {trend.isPositive ? (
                <ArrowUpRight className="w-3 h-3" />
              ) : (
                <ArrowDownRight className="w-3 h-3" />
              )}
              {Math.abs(trend.value).toFixed(1)}%
            </span>
          )}
          {subtitle && <span className="text-text-muted">{subtitle}</span>}
        </div>
      )}
    </div>
  );
}

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}
